module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_06-c6d5f5c3a7e93b4a82dd2b366adb5080.png";